import { Position, Toaster, Intent } from '@blueprintjs/core';
import type { AxiosError } from 'axios';

const AppToaster = Toaster.create({
  className: 'recipe-toaster',
  position: Position.TOP_RIGHT,
});

export const showGlobalError = (
  message = 'Error happened, please refresh the page and try again!'
) => AppToaster.show({ message, intent: Intent.DANGER });

export const showError = (message: string | JSX.Element) => {
  AppToaster.show({ message, intent: Intent.DANGER });
};

const getNonFieldErrors = (data: unknown): string[] | undefined => {
  if (!data || typeof data !== 'object') {
    return undefined;
  }
  const candidate = (data as ValidationErrors<unknown>).non_field_errors;
  return Array.isArray(candidate) ? candidate : undefined;
};

export const showAxiosError = (error: AxiosError<unknown>) => {
  if (error.response) {
    const nonFieldErrors = getNonFieldErrors(error.response.data);
    if (error.response.status === 400 && nonFieldErrors) {
      nonFieldErrors.forEach((m: string) => showError(m));
    } else if (error.response.status === 400) {
      showError('Validation error happend! Please check the input.');
    } else {
      showGlobalError();
    }
  } else {
    showGlobalError();
  }
};

export default AppToaster;
